/**
 * @generated SignedSource<<2bcfd83a1cbd994c2e0d281279f9c347>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GoogleSettings_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GoogleCredentials_data">;
  readonly " $fragmentType": "GoogleSettings_data";
};
export type GoogleSettings_data$key = {
  readonly " $data"?: GoogleSettings_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"GoogleSettings_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoogleSettings_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoogleCredentials_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "86320016e60cc4aa19edc9fd090e6c76";

export default node;
